<template>
  <div id="log-in-page" class="main-page">
    <div class="container">
      <div class="row row-login-form">
        <div class="col-xl-6 col-lg-6 col-md-5 col-sm-12 text-center col-login-left">
         <img class="login-img" :src="login_img" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-7 col-sm-12 col-login-right">
          <div v-if="!resetsuccess" class="before-sent-reset">
            <p class="login-title">Password Recovery</p>
              <p
                class="application-sign-in-text"
              >Enter your email address and we will send you a link to reset your password.</p>
            <emailInputBase
              required
              v-model="user_email"
              label="Email"
              :nameclass="{
                    'error register-input': $v.user_email.$error,
                    'login-input': !$v.user_email.$error,
                  }"
              @validateEmail="
                    (a) => {
                      isValidEmail = a;
                    }
                  "
            />

            <div class="form-btn-section text-center">
              <button
                class="blue-cta login-btn"
                type="submit"
                :disabled="loading"
                @click="on_submit()"
              ><i v-if="loading" class="fa fa-spinner fa-pulse fa fa-fw"></i> {{loading?'Recovering':'Recover Password'}}</button>
            </div>

            <div class="text-center">
              <router-link class="login-link" :to="{ name: 'login' }">Login</router-link>
              <p class="application-sign-in-text">
                Don't have an account?
                <span>
                  <router-link :to="{ name:'register' }" class="application-sign-in-link">Sign Up</router-link>
                </span>
              </p>
            </div>
          </div>
          <div v-else class="after-sent-reset-success">
            <p class="login-title">please check your email to reset password</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  emailInputBase,
} from "../components/forms/baseForms";
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required, minLength, url, email } from "vuelidate/lib/validators";
Vue.use(Vuelidate);
export default {
  name: "Recover",
  components: {
    emailInputBase
  },
  props: {
    msg: String
  },
  data: () => {
    return {
    login_img: require("@/assets/images/login.png"),
      user_email: "",
      resetsuccess: false,
      isValidEmail: null,
      loading: false
    };
  },
  methods: {
    on_submit() {
      this.$v.user_email.$touch()
      if (this.$v.user_email.$invalid) {
        return
      }
      this.isValidEmail = false;
      this.loading = true;
      this.$store
        .dispatch("requestReset", {
          email: this.user_email
        })
        .then(res => {
          if (res.status == 200) {
            this.$router.push({ name: "login", query: { message: "requestreset" } })
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          // console.log(err);
        });
    }
  },
  validations: {
    user_email: {
      required,
      minLength: minLength(5),
      email
    },

  },
};
</script>

<style scoped>
.blue-cta:disabled {
  background-image: linear-gradient(45deg, #6c757d 0, #6c757d 100%);
}
.register-input {
    margin-bottom: 35px;
}
.login-error {
  color: #e57373;
  font-weight: 500;
  margin-bottom: 30px;
}

#log-in-page label {
  width: 100%;
  font-weight: 500;
}

#log-in-page input {
  width: 100%;
  padding: 8px 10px;
}

.login-title {
  font-size: 32px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 35px;
}

.login-input {
  margin-bottom: 35px;
}

.row-login-form {
  border-radius: 4px;
  margin: 50px 0 100px 0;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.col-login-right {
  background: #e3f2fd;
  padding: 96px 64px !important;
}

.login-link,
.recover-password-link {
  font-size: 18px;
  font-weight: 500;
  color: #2196f3;
  display: inline-block;
  margin: 25px;
}

.login-link:hover,
.recover-password-link:hover {
  color: #1976d2;
  text-decoration: none;
}

.application-sign-in-link {
  color: #2196f3;
}

.application-sign-in-link:hover {
  color: #1976d2;
  text-decoration: none;
}

@media (max-width: 1199.98px) {
  .row-login-form {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
}

@media (max-width: 767.98px) {
  .col-login-left {
    display: none;
  }

  .col-login-right {
    padding: 32px !important;
  }

  .row-login-form {
    margin-bottom: 50px;
  }
}
</style>
